<template>
  <div class="loading-components">
    <ContentNotify />
    <Loading />
    <CurrentPopup />
    <CurrentActionSheet />
  </div>
</template>

<script>
import ContentNotify from './components/content-notify';
import Loading from './components/loading';
import CurrentPopup from './components/current-popup';
import CurrentActionSheet from './components/current-action-sheet';
export default {
  components: { ContentNotify, Loading, CurrentPopup, CurrentActionSheet }
}
</script>